var defaultOptions = {};
export function getDefaultOptions() {
  return defaultOptions;
}
export function setDefaultOptions(newOptions) {
  defaultOptions = newOptions;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/date-fns/esm/_lib/defaultOptions/index.js
// module id = 28
// module chunks = 0 1